// only for doctor
import { FontAwesome, Ionicons, MaterialIcons } from "@expo/vector-icons";
import React, { useEffect } from "react";
import {
  Dimensions,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
  Animated,
} from "react-native";
import { StepHeader, Button, Row, Centered, Loading } from "../../../components/all";
import colors from "../../../constants/colors";
import Styles from "../../../constants/styles";
import { useDispatch, useSelector } from "react-redux";
import { addFields } from "../../../reducers/auth/register";
import { useIsFocused } from "@react-navigation/native";
import { jobTypes } from "../../../constants/lov/professions";

const companyTypes = [
  {
    id: 1,
    icon: "local-hospital",
    iconType: "MaterialIcons",
    name: `Medical\nFacility`,
    displayName: "Medical Facility",
    description: "For medical facilities such as Clinics, Hospitals, Pharmacies and other Healthcare related organizations.",
    color: "#4B9BFF",
    bgColor: "#E3F2FF",
  },
  {
    id: 2,
    icon: "people",
    iconType: "MaterialIcons",
    name: `Recruitment\nAgency`,
    displayName: "Recruitment Agency",
    description: "For recruitment agencies looking to hire talent in the medical field such as Doctors, Nurses & Pharmacists.",
    color: "#FF6B6B",
    bgColor: "#FFE5E5",
  },
];


export default function StepType({ navigation, setField, route }) {
  let fromPostJob = route?.name === "PostJobScreen";
  const pageTitle = fromPostJob ? "Job Type" : "Select Your Organization";
  const types = fromPostJob ? jobTypes.map((type, index) => ({
    ...type,
    displayName: type.name,
    color: ["#4B9BFF", "#10B981", "#EF4444", "#F59E0B", "#8B5CF6"][index % 5],
    bgColor: ["#E3F2FF", "#D1FAE5", "#FEE2E2", "#FEF3C7", "#EDE9FE"][index % 5],
    iconType: "MaterialIcons",
    icon: ["access-time", "business", "public", "date-range", "description"][index % 5],
  })) : companyTypes;
  const dispatch = useDispatch();
  const { isDev } = useSelector((state) => state.user);
  const isFocused = useIsFocused();
  const [collapseIdx, setCollapseIdx] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [animatedValues] = React.useState(types.map(() => new Animated.Value(0)));
  const input = {
    emailCode: "emailCode",
    isGP: "isGP",
    isSpecialist: "isSpecialist",
  };

  const [selectedExpertise, setSelectedExpertise] = React.useState(null);

  const onSelectItem = (item, index) => {
    setSelectedExpertise(item);
    if (item.types) {
      setCollapseIdx(index);
      setSelectedExpertise(null);
    } else {
      setCollapseIdx(null);
      setSelectedExpertise(item);
      console.log(item);
    }
  };

  useEffect(() => {
    if (!isDev) {
      let fields = {
        type: 0,
      };
      // Default to clinic registration flow (StepFacility)
      navigation.navigate(fromPostJob ? "PostProfessionScreen" : "StepFacility", {
        jobType: 0,
      });
      dispatch(addFields(fields));
    } else {
      setIsLoading(false);
      // Animate cards entrance
      animatedValues.forEach((animValue, index) => {
        Animated.timing(animValue, {
          toValue: 1,
          duration: 400,
          delay: index * 100,
          useNativeDriver: true,
        }).start();
      });
    }
  }, [isFocused]);


  if (isLoading) {
    return <>
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <Loading visible={true} />
      </View>
    </>;
  }

  return (
    <>
      <ScrollView
        style={{
          ...Styles.webSmallContainer,
          marginTop: fromPostJob ? 48 : 80,
        }}
      >
        <StepHeader
          label={pageTitle}
          icon={fromPostJob ?
            <MaterialIcons name="work" size={28} /> :
            <MaterialIcons name="business" size={28} />
          }
          subtitle={fromPostJob ?
            `Choose the type of position you're looking to fill` :
            `Select your organization type to connect with the right healthcare professionals`
          }
        />
        <View
          style={{
            width: "100%",
            marginTop: 24,
            paddingHorizontal: 20,
          }}
        >
          {types.map((item, index) => {
            const isSelected = selectedExpertise?.id === item.id;
            return (
              <TouchableOpacity
                key={item.id}
                onPress={() => {
                  onSelectItem(item, index);
                  // Animate the selection
                  // Animated.spring(animatedValues[index], {
                  //   toValue: isSelected ? 0 : 1,
                  //   useNativeDriver: true,
                  //   tension: 50,
                  //   friction: 7,
                  // }).start();
                }}
                style={{ marginBottom: 16 }}
                activeOpacity={0.7}
              >
                <Animated.View
                  style={{
                    ...styles.rowCard,
                    borderColor: isSelected ? item.color : "#F3F4F6",
                    backgroundColor: isSelected ? item.bgColor : "white",
                    opacity: animatedValues[index],
                    transform: [
                      {
                        translateY: animatedValues[index].interpolate({
                          inputRange: [0, 1],
                          outputRange: [20, 0],
                        }),
                      },
                      {
                        scale: isSelected ? 0.98 : 1,
                      },
                    ],
                    shadowOpacity: isSelected ? 0.15 : 0.08,
                  }}
                >
                  <View style={{ flexDirection: "row", alignItems: "center" }}>

                    <View style={{ flex: 1 }}>
                      <View style={{ flex: 1, flexDirection: 'row' }}>
                        <View
                          style={{
                            width: 24,
                            height: 24,
                            backgroundColor: isSelected ? item.color : item.bgColor,
                            borderRadius: 24,
                            marginRight: 12,
                            marginBottom: 4,
                            alignSelf: "flex-start",
                            justifyContent: "center",
                            alignItems: "center"
                          }}
                        >
                          <MaterialIcons
                            name={item.icon}
                            size={18}
                            color={isSelected ? "white" : item.color}
                          />
                        </View>
                        <Text
                          style={{
                            fontSize: 18,
                            fontWeight: "700",
                            marginBottom: 6,
                            color: isSelected ? item.color : "#1F2937",
                            letterSpacing: -0.5,
                          }}
                        >
                          {item.displayName || item.name.replace(/\\n/g, ' ')}
                        </Text>
                      </View>
                      <Text
                        style={{
                          fontSize: 14,
                          color: isSelected ? "#4B5563" : "#6B7280",
                          lineHeight: 20,
                          letterSpacing: -0.1,
                        }}
                      >
                        {item.description}
                      </Text>
                    </View>
                  </View>
                </Animated.View>
              </TouchableOpacity>
            );
          })}
        </View>
        <View style={{ marginBottom: 48 }} />
      </ScrollView>
      <Centered
        style={{
          position: "fixed",
          bottom: 32,
          backgroundColor: "white",
          width: "100%",
          paddingHorizontal: 24,
        }}
      >
        <Row style={{ marginBottom: 24 }}>
          <Button
            label="Back"
            type={"secondary"}
            onPress={() => {
              navigation.goBack();
            }}
          />
          <Button
            label="Next"
            type={"primary"}
            onPress={() => {
              if (selectedExpertise) {
                let fields = {
                  type: selectedExpertise.id,
                };

                dispatch(addFields(fields));
                // Navigate based on organization type:
                // Doctor (id=1) -> StepProfession
                // Clinic (id=0) or Agency (id=2) -> StepFacility
                let targetScreen;
                if (fromPostJob) {
                  targetScreen = "PostProfessionScreen";
                } else {
                  targetScreen = selectedExpertise.id === 1 ? "StepFacility" : "StepFacility";
                }
                navigation.navigate(targetScreen, {
                  jobType: selectedExpertise.id,
                });
              } else {
                alert("Please select your " + pageTitle);
              }
            }}
          />
        </Row>
      </Centered>
    </>
  );
}

const styles = {
  category: {
    height: 250,
    justifyContent: "center",
    margin: 6,
    marginTop: 10,
    paddingHorizontal: 24,
    alignItems: "center",
    borderWidth: 1,
    borderRadius: 18,
    width: "80%",
  },
  rowCard: {
    padding: 12,
    paddingHorizontal: 18,
    borderWidth: 2,
    borderRadius: 20,
    width: "100%",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.08,
    shadowRadius: 12,
    elevation: 3,
    minHeight: 110,
    justifyContent: "center",
  },
};
